//
// Copyright (C) 2020 StaffPad Ltd. All rights reserved.
//

import React from 'react';

export default props =>
    <div id={props.id} className={`spinner-border text-info ${props.className || ''}`} role="status">
        <span className="sr-only">Loading...</span>
    </div>;